// @flow

import {DetailLoadingPage} from 'app/general/loading/DetailLoadingPage';
import loadByHashid, {
  type LoadByHashidInjectedProps,
} from 'app/general/loadByHashid';
import loadVersions, {
  type LoadVersionsInjectedProps,
} from 'app/general/loadVersions';
import {
  fetchProcessDetailByHashid,
  getProcessVersionByID,
} from 'app/process/actions';
import {denormalizeProcessFactory} from 'app/process/selectors';

export type {LoadByHashidInjectedProps, LoadVersionsInjectedProps};

export const loadProcessByHashid = loadByHashid(
  ({hashid}) => fetchProcessDetailByHashid(hashid),
  ['processArea', ['processes', 'byId']],
  DetailLoadingPage,
  denormalizeProcessFactory
);

export const loadProcessVersionByVersionId = loadVersions({
  fetchVersionsAction: getProcessVersionByID,
  storeMap: ['processArea', ['versions']],
  LoadingComponent: DetailLoadingPage,
  fetchParamBuilder: (props) => props.params.versionid,
  waitForObjectVersion: true,
});
